/* eslint-disable react-refresh/only-export-components */
import { createFileRoute } from '@tanstack/react-router';
import { fetchPlanDetail } from '@/api/capa';
import { queryClient } from '@/lib/utils/queryClient';
import { PlanDetailContent } from '../../../../-components/PlanDetailContent';

export const Route = createFileRoute(
  '/(client)/capa/(pages)/(detail)/plans/$id/',
)({
  loader: ({ params }) =>
    queryClient.ensureQueryData({
      queryKey: ['capa-plan-detail', params.id],
      queryFn: () => fetchPlanDetail(params.id),
    }),
  component: CapaPlanDetailPage,
});

function CapaPlanDetailPage() {
  const { id } = Route.useParams();
  return (
    <div className='h-[calc(100vh-58px)] overflow-y-auto'>
      <PlanDetailContent id={id} />
    </div>
  );
}
